import PersonMissions from './PersonMissions';

export default PersonMissions;
